const PencilIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path
            d="M9.60006 4.26696L11.7334 6.40035M12.8929 5.23333C13.1748 4.95142 13.3333 4.56903 13.3333 4.17029C13.3334 3.77156 13.175 3.38913 12.8931 3.10715C12.6112 2.82516 12.2288 2.66672 11.8301 2.66667C11.4314 2.66662 11.049 2.82497 10.767 3.10688L3.64904 10.2265C3.52521 10.35 3.43363 10.502 3.38237 10.6692L2.67783 12.9903C2.66405 13.0364 2.663 13.0854 2.67482 13.1321C2.68663 13.1788 2.71085 13.2214 2.74492 13.2554C2.77899 13.2894 2.82163 13.3135 2.86832 13.3253C2.915 13.337 2.964 13.3359 3.0101 13.322L5.33172 12.618C5.49875 12.5672 5.65075 12.4762 5.77439 12.353L12.8929 5.23333Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default PencilIcon;
